var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.982 13.029V11.665C10.982 11.3064 10.9113 10.9513 10.774 10.62C10.6366 10.2887 10.4354 9.98773 10.1816 9.73428C9.9279 9.48083 9.62671 9.27988 9.29526 9.14291C8.96382 9.00594 8.60863 8.93564 8.25 8.93604H3.479C2.75522 8.93604 2.06109 9.22356 1.54931 9.73534C1.03752 10.2471 0.75 10.9413 0.75 11.665V13.029",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59472 3.479C8.59472 4.01879 8.43464 4.54645 8.13473 4.99526C7.83482 5.44406 7.40855 5.79384 6.90983 6.00036C6.41111 6.20688 5.86235 6.26087 5.33295 6.15549C4.80355 6.05011 4.31729 5.7901 3.93567 5.40834C3.55405 5.02658 3.29422 4.54023 3.18904 4.01079C3.08385 3.48135 3.13803 2.93261 3.34474 2.43396C3.55144 1.93532 3.90138 1.50918 4.3503 1.20943C4.79921 0.909687 5.32693 0.749802 5.86672 0.75C6.59032 0.750265 7.2842 1.0379 7.79577 1.54966C8.30734 2.06142 8.59472 2.7554 8.59472 3.479Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 6.20799L13.0281 7.57199L15.7571 4.84399",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthor);
export default __webpack_public_path__ + "static/media/author.8aacac1e529650a0bfa301669738fe65.svg";
export { ForwardRef as ReactComponent };